<template>
  <div style="padding: 5px">
    <div style="margin: 10px;display: flex;justify-content: space-between;align-items: center;margin-right: 30px">
      <div style="font-size: 20px">{{ $t('protocol.title') }}</div>
      <div>
        <a-space>
          <!-- <a-button key="submit" type="primary" @click="toProtocolInsertView">新增</a-button> -->
          <a-input @keyup.enter="handleSearch" :placeholder="$t('protocol.searchCodeOrName')" v-model="protocolCode" style="width: 260px" />
          <a-button type="primary" @click="handleSearch" v-if="authorities.find(a => a.code === 'device:manage:device:protocol:query')">{{ $t('buttons.search') }}</a-button>
          <a-button type="primary" v-if="authorities.find(a => a.code === 'device:manage:device:protocol:insert')" @click="toProtocolInsertView">{{ $t('buttons.add') }}</a-button>
          <a-upload
            accept=".xls, .xlsx"
            :showUploadList="false"
            :customRequest="importProtocol"
          >
            <a-button type="primary" :loading="isImporting">{{ $t('protocol.importP') }}</a-button>
          </a-upload>
          <a-button type="danger" v-if="authorities.find(a => a.code === 'device:manage:device:protocol:delete')" @click="removeProtocol">{{ $t('buttons.delete') }}</a-button>
        </a-space>
      </div>
    </div>
    <a-table
      :columns="columns"
      :data-source="list"
      :loading="loading"
      :row-key="record => record.code"
      :row-selection="rowSelection"
      :pagination="pagination"
      :scroll="scroll"
      @change="tableChange"
    >
      <template v-slot:protocolCode="text">
        <text-highlight :queries="[highLightInfo.protocolCode]">{{text}}</text-highlight>
      </template>
      <template v-slot:protocolName="text">
        <text-highlight :queries="[highLightInfo.protocolName]">{{text}}</text-highlight>
      </template>
      <template v-slot:protocolType="text, record">
        {{ record.type === 'public' ? $t('protocol.public') : $t('protocol.private') }}
      </template>
      <template v-slot:updatedAt="text, record">
        {{ moment(record.updatedAt).format('YYYY-MM-DD HH:mm:ss') }}
      </template>
      <template v-slot:createdAt="text, record">
        {{ moment(record.createdAt).format('YYYY-MM-DD HH:mm:ss') }}
      </template>
      <template #operation="text, record">
        <a-button style="padding: 0; padding-right: 8px" type="link" :disabled="!authorities.find(a => a.code === 'device:manage:device:protocol:update')" @click="$router.push({ path: '/equipment/protocol/submit', query: { code: record.code, driverType: record.driver } })">{{ $t('buttons.edit') }}</a-button>
        <a-button style="padding: 0; padding-left: 8px" type="link" @click="visible = true; newCode = record.code; oldCode = record.code">{{ $t('role.copy') }}</a-button>
      </template>
    </a-table>
    <a-modal
      :title="$t('protocol.copy')"
      :visible="visible"
      :confirm-loading="confirmLoading"
      @ok="handleOk"
      @cancel="handleCancel"
    >
      <a-form-model-item :label="$t('common.protocolCode')">
        <a-input v-model="newCode" />
      </a-form-model-item>
    </a-modal>
  </div>
</template>

<script>
import moment from 'moment'
import { protocolApi } from '@/api/station'
import { getProtocolList, deleteProtocol, copyProtocol, importProtocl } from '@/api/protocol'
import TextHighlight from 'vue-text-highlight'

export default {
  name: 'index',
  components: {TextHighlight},
  activated() {
    if (this.$store.state.protocolFlag) {
      this.getList()
      this.$store.commit('setProtocolFlag', false)
    }
    // 
    const a = JSON.parse(sessionStorage.getItem('authorities'))
    if (a?.length) {
      this.authorities = a
    } else {
      this.authorities = this.getAuthorities(this.$route.path)
    }
  },
  data () {
    return {
      searchInput: null,
      visible: false,
      confirmLoading: false,
      newCode: '',
      oldCode: '',
      authorities: [],
      highLightInfo: {
        protocolCode: '',
        protocolName: ''
      },
      columns: [
        {
          title: () => this.$t('common.protocolCode'),
          dataIndex: 'code',
          key: 'protocolCode',
          width: 150,
          scopedSlots: { customRender: 'protocolCode' }
        },
        {
          title: () => this.$t('protocol.name'),
          dataIndex: 'name',
          key: 'protocolName',
          width: 150,
          scopedSlots: { customRender: 'protocolName' }
        },
        {
          title: () => this.$t('protocol.type'),
          dataIndex: 'protocolType',
          key: 'protocolType',
          scopedSlots: { customRender: 'protocolType' }
        },
        {
          title: () => this.$t('common.driverType'),
          dataIndex: 'driver',
          key: 'driver'
        },
        {
          title: () => this.$t('common.remark'),
          dataIndex: 'remark',
          key: 'remark'
        },
        {
          title: () => this.$t('protocol.intervalTime'),
          dataIndex: 'intervalTime',
          key: 'intervalTime'
        },
        {
          title: () => this.$t('protocol.timeout'),
          dataIndex: 'timeout',
          key: 'timeout'
        },
        {
          title: () => this.$t('protocol.retryCnt'),
          dataIndex: 'retryCnt',
          key: 'retryCnt'
        },
        {
          title: () => this.$t('common.updatedAt'),
          dataIndex: 'updatedAt',
          key: 'updatedAt',
          scopedSlots: { customRender: 'updatedAt' }
        },
        {
          title: () => this.$t('common.createdAt'),
          dataIndex: 'createdAt',
          key: 'createdAt',
          scopedSlots: { customRender: 'createdAt' }
        },
        {
          title: () => this.$t('common.operation'),
          dataIndex: 'operation',
          key: 'operation',
          align: 'center',
          scopedSlots: { customRender: 'operation' },
          fixed: 'right'
        }
      ],
      list: [],
      state: '',
      rowSelection: {
        selectedRowKeys: [],
        onChange: this.onChange,
        onSelect: this.onSelect,
        onSelectAll: this.onSelectAll
      },
      loading: false,
      searchInfo: {
        text: {
          protocolCode: '',
          protocolName: ''
        },
        column: {
          protocolCode: false,
          protocolName: false
        }
      },
      sortInfo: [],
      pagination: {
        current: 1,
        pageSize: 10,
        total: 0,
        pageSizeOptions: ['10', '20', '30', '40', '50'],
        showSizeChanger: true
      },
      protocolCode: '',
      protocolName: '',
      scroll: {
        x: false
      },
      isImporting: false
    }
  },
  mounted () {
    const width = window.innerWidth
      if (width < 1600) {
        this.scroll.x = 1350
      } else if (width < 1900) {
        this.scroll.x = 1647
      } else {
        this.scroll.x = false
      }
  },
  methods: {
    moment,
    getList (page = 1, size = 10) {
      this.loading = true
      getProtocolList(page, size, this.protocolCode, this.protocolCode).then(({ data }) => {
        this.list = data.records
        this.pagination.current = data.current
        this.pagination.pageSize = data.size
        this.pagination.total = data.total
        this.highLightInfo.protocolCode = this.highLightInfo.protocolName = this.protocolCode
      }).catch(() => {
        // this.$message.error("请求失败")
      }).finally(() => {
        this.loading = false
      })
    },
    handleSearch() {
      this.pagination.current = 1
      this.getList(this.pagination.current, this.pagination.pageSize)
    },
    onChange (selectedRows) {
      this.rowSelection.selectedRowKeys = selectedRows
    },
    onSelect (record, selected, selectedRows) {},
    onSelectAll (selected, selectedRows, changeRows) {},
    async tableChange (pagination) {
      this.getList(pagination.current, pagination.pageSize)
    },
    toProtocolInsertView () {
      this.$router.push({ path: '/equipment/protocol/submit' })
    },
    removeProtocol () {
      if (this.rowSelection.selectedRowKeys.length === 0) {
        this.$message.warn(this.$t('protocol.atLeastOnePro'))
        return
      }
      deleteProtocol(this.rowSelection.selectedRowKeys).then(({ message }) => {
        this.$message.success(message)
        this.rowSelection.selectedRowKeys = []
        this.getList(this.pagination.current, this.pagination.pageSize)
      }).catch(() => {})
      // const list = this.list.filter(item => this.rowSelection.selectedRowKeys.indexOf(item.protocolCode) !== -1)
      // protocolApi.delete(list).then(() => {
      //   this.$message.success('删除成功')
      //   this.getList()
      // }).catch(() => {
      //   // this.$message.error("请求失败")
      // })
      console.log(this.rowSelection.selectedRowKeys)
    },
    async handleReset (clearFilters, dataIndex) {
      clearFilters()
      this.searchInfo.text[dataIndex] = ''
      this.searchInfo.column[dataIndex] = false
      try {
        const r = await protocolApi.queryAndSort(this.pagination.current, this.pagination.pageSize, {
          model: this.searchInfo.text,
          sort: this.sortInfo
        })
        this.list = r.data.content
        this.pagination.current = r.data.number + 1
        this.pagination.pageSize = r.data.size
        this.pagination.total = r.data.totalElements
      } catch {
        // this.$message.error("请求失败")
      }
    },
    async handleOk() {
      if (this.newCode === this.oldCode) {
        return this.$message.warn(this.$t('protocol.new'))
      }
      this.confirmLoading = true
      try {
        const { message } = await copyProtocol({
          code: this.oldCode,
          newCode: this.newCode
        })
        this.$message.success(message)
        this.getList()
        this.visible = false
      } catch(e) {
        console.log(e)
      } finally {
        this.confirmLoading = false
      }
    },
    handleCancel() {
      this.visible = false
      this.newCode = ''
      this.oldCode = ''
    },
    async importProtocol(f) {
      this.isImporting = true
      try {
        const { message } = await importProtocl(f.file)
        this.getList(this.pagination.current, this.pagination.pageSize)
        this.$message.success(message)
      } catch(e) {
        console.log(e)
      } finally {
        this.isImporting = false
      }
    }
  }
}
</script>

<style lang="less" scoped>
.row {
  margin-top: 5px;
}
.highlight {
  background-color: rgb(255, 192, 105);
  padding: 0px;
}
.ant-table-column-title span {
  position: relative;
}
.ant-table-column-title .anticon-caret-up {
  position: absolute;
  top: -1px;
  right: -18px;
  font-size: 14px;
  color: #ccc;
}
.ant-table-column-title span.ASC .anticon-caret-up {
  color: #1890ff;
}
.ant-table-column-title span.DESC .anticon-caret-down {
  color: #1890ff;
}
.ant-table-column-title .anticon-caret-down {
  position: absolute;
  top: 8px;
  right: -18px;
  font-size: 14px;
  color: #ccc;
}
/deep/ .ant-table-tbody .ant-table-row:nth-child(2n) {
  background: rgb(250, 250, 250)
}
.ant-table-column-title div {
  position: relative;
}
.ant-table-column-title span {
  position: relative;
}
.ant-table-column-title .anticon-caret-up {
  position: absolute;
  top: -1px;
  right: -18px;
  font-size: 14px;
  color: #ccc;
}
.ant-table-column-title span.ASC .anticon-caret-up {
  color: #1890ff;
}
.ant-table-column-title span.icons {
  position: absolute;
  right: 18px;
}
.ant-table-column-title span.DESC .anticon-caret-down {
  color: #1890ff;
}
.ant-table-column-title .anticon-caret-down {
  position: absolute;
  top: 8px;
  right: -18px;
  font-size: 14px;
  color: #ccc;
}
</style>
